<template id="rolePermission">
  <div id="roleTree">
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">菜單管理</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'roleList' }">角色列表</router-link>
              </li>
              <li class="breadcrumb-item active">菜單管理</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <div class="content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-md-8 col-sm-12">
            <div class="card card-primary">
              <div class="card-body">
                <div class="row">
                  <div class="col-sm-8">
                    <el-form
                      ref="roleform"
                      :model="roleModel"
                      :rules="roleRules"
                      label-width="120px"
                    >
                      <el-form-item label="菜單">
                        <el-button
                          @click="changefold()"
                          style="margin-bottom: 10px"
                          >{{ status }}</el-button
                        >
                        <el-tree
                          :data="menuList"
                          ref="permissiontree"
                          show-checkbox
                          expand
                          node-key="id"
                          :default-expand-all="false"
                          :default-checked-keys="getcheckList"
                          :props="defaultProps"
                        ></el-tree>
                      </el-form-item>
                      <el-form-item>
                        <el-button @click="addrole('roleform')">保存</el-button>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Message } from "element-ui";
export default {
  data() {
    return {
      roleModel: {
        roleName: "",
        remark: "",
      },
      status: "展開",
      foldbtn: false,
      //默认选中
      checkList: [], // ['1014'],
      roleRules: {},
      checkKeys: [],
      permissionList: [],
      defaultProps: {
        id: "id",
        children: "menuDto",
        label: "sgL_Name",
      },
      menuList: [],
    };
  },
  async created() {
    await this.GetMenuForId();
    this.GetAllMenu();
  },
  methods: {
    async GetMenuForId() {
      const res = await this.$api.permissionApi.getRoleMenu({
        SGL_RoleId: this.$route.query.Id,
      });
      if (res.data.success) {
        if (res.data.result) {
          res.data.result.forEach((item) => {
            this.checkList.push(item.id);
            if (item.menuDto) {
              item.menuDto.map((abc) => {
                this.checkList.push(abc.id);
              });
            }
          });
        }
      } else {
        Message({
          type: "error",
          message: "錯誤" + res.data.error.message,
        });
      }
    },
    GetAllMenu() {
      this.$api.permissionApi.getAllMenu().then((res) => {
        if (res.data.success) {
          this.menuList = res.data.result;
        } else {
          Message({
            type: "error",
            message: "錯誤" + res.data.error.message,
          });
        }
      });
    },
    addrole(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$api.permissionApi
            .UpdateMenu({
              id: this.$route.query.Id,
              sgL_MenuSystemList: this.$refs.permissiontree
                .getCheckedKeys()
                .join(),
            })
            .then((res) => {
              if (res.data.success) {
                Message({
                  type: "success",
                  message: this.$t('message.operatesuccessfully'),
                });
                this.GetMenuForId();
              } else {
                Message({
                  type: "error",
                  message: "錯誤" + res.data.error.message,
                });
              }
            });
        } else {
          Message({
            type: "error",
            message: "請填寫必填數據",
          });
          return false;
        }
      });
    },
  },
  computed: {
    getPermissionList() {
      return this.permissionList;
    },
    getroleModel() {
      return this.roleModel;
    },
    getcheckList() {
      return this.checkList;
    },
    getfoldbtn() {
      return this.foldbtn;
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/AdminUser/roleMenu.vue